import { render, staticRenderFns } from "./CaseStudyScreen.vue?vue&type=template&id=12271356"
import script from "./CaseStudyScreen.vue?vue&type=script&lang=js"
export * from "./CaseStudyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports